import React, { useState, useEffect } from 'react';
import { Race } from '../types';
import { fetchCompletedRaces } from '../services/dataService';
import ResultsHistoryView from './results/ResultsHistoryView';

const ResultsHistory: React.FC = () => {
  const [races, setRaces] = useState<Race[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchResults = async () => {
    try {
      setLoading(true);
      setError(null);
      const completedRaces = await fetchCompletedRaces();
      setRaces(completedRaces);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch results';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResults();
  }, []);

  return (
    <ResultsHistoryView
      races={races}
      loading={loading}
      error={error}
      onRetry={fetchResults}
      showSubscriberLinks
    />
  );
};

export default ResultsHistory;
